if (typeof ProductQuantityQuickView !== 'function') {
  /*
  class ProductQuantityQuickView extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const initializeControls = () => {
        // Find elements
        const qty = this.querySelector('.product-quantity__selector');
        const qtyMinus = this.querySelector('.product-quantity__minus');
        const qtyPlus = this.querySelector('.product-quantity__plus');

        if (!qty || !qtyMinus || !qtyPlus) return false;

        // Get min and max values
        const minOrder = parseInt(qty.getAttribute('data-pedido-minimo')) ||
                         parseInt(qty.getAttribute('min')) || 600;
        const qtyMax = qty.hasAttribute('max') ? parseInt(qty.getAttribute('max')) : 999999;
        const maxMultiple = Math.floor(qtyMax / minOrder) * minOrder;

        const updateQuantity = (newValue) => {
          // Round to nearest multiple of minOrder
          let value = Math.round(newValue / minOrder) * minOrder;
          // Ensure within bounds
          value = Math.max(minOrder, Math.min(value, maxMultiple));

          // Update input value
          qty.value = value;

          // Update button states
          qtyMinus.classList.toggle('disabled', value <= minOrder);
          qtyPlus.classList.toggle('disabled', value + minOrder > maxMultiple);

          // Trigger change event
          qty.dispatchEvent(new Event('change', { bubbles: true }));
        };

        // Remove existing listeners by cloning
        const newQtyMinus = qtyMinus.cloneNode(true);
        const newQtyPlus = qtyPlus.cloneNode(true);
        qtyMinus.parentNode.replaceChild(newQtyMinus, qtyMinus);
        qtyPlus.parentNode.replaceChild(newQtyPlus, qtyPlus);

        // Add new listeners
        newQtyMinus.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          const currentValue = parseInt(qty.value) || minOrder;
          updateQuantity(currentValue - minOrder);
        }, true);

        newQtyPlus.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          const currentValue = parseInt(qty.value) || minOrder;
          updateQuantity(currentValue + minOrder);
        }, true);

        // Handle direct input changes
        qty.addEventListener('input', () => {
          if (qty.value !== '') {
            updateQuantity(parseInt(qty.value) || minOrder);
          }
        });

        qty.addEventListener('blur', () => {
          updateQuantity(parseInt(qty.value) || minOrder);
        });

        // Initialize with current value
        updateQuantity(parseInt(qty.value) || minOrder);

        return true;
      };

      if (!initializeControls()) {
        setTimeout(initializeControls, 100);
      }
    }
  }
  */

  if (typeof customElements.get('product-quantity-quick-view') == 'undefined') {
    // customElements.define('product-quantity-quick-view', ProductQuantityQuickView);
  }
}